import "./Blog.module.css";
import Header from "@/reusable_sections/Header";
import InzichtenHerstel from "./sections/InzichtenHerstel";
import NewsletterSignup from "./sections/NewsletterSignup";
import Footer from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <Header />
      <InzichtenHerstel />
      <NewsletterSignup />
      <Footer />
    </div>;
}